import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/app-store': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M255.9 120.9L265 105.2C270.6 95.4 283.1 92.1 292.9 97.7 302.7 103.3 306 115.8 300.4 125.6L212.9 277.1H276.2C296.7 277.1 308.2 301.2 299.3 317.9H113.8C102.5 317.9 93.4 308.8 93.4 297.5 93.4 286.2 102.5 277.1 113.8 277.1H165.8L232.4 161.7 211.6 125.6C206 115.8 209.3 103.4 219.1 97.7 228.9 92.1 241.3 95.4 247 105.2L255.9 120.9zM177.2 338.9L157.6 372.9C152 382.7 139.5 386 129.7 380.4 119.9 374.8 116.6 362.3 122.2 352.5L136.8 327.3C153.2 322.2 166.6 326.1 177.2 338.9zM346.1 277.2H399.2C410.5 277.2 419.6 286.3 419.6 297.6 419.6 308.9 410.5 318 399.2 318H369.7L389.6 352.5C395.2 362.3 391.9 374.7 382.1 380.4 372.3 386 359.9 382.7 354.2 372.9 320.7 314.8 295.5 271.3 278.8 242.3 261.7 212.8 273.9 183.2 286 173.2 299.4 196.2 319.4 230.9 346.1 277.2zM256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM472 256C472 374.7 375.9 472 256 472 137.3 472 40 375.9 40 256 40 137.3 136.1 40 256 40 374.7 40 472 136.1 472 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/app-store.js
// module id = v3Ob
// module chunks = 144